import LegalShell, { Fill, LegalSection } from "@/components/LegalShell";
import { COMPANY as C } from "@/pages/legal/companyInfo";
import Seo from "@/components/Seo";

export default function Terms() {
  return (
    <LegalShell eyebrow="Conditions" title="Conditions Générales d'Utilisation et de Vente" updated={C.updated}>
      <Seo title="Conditions générales (CGU/CGV) — BIZARRE AI" description="Conditions générales d'utilisation et de vente de BIZARRE AI : service, abonnements, résiliation." path="/cgu" />
      <LegalSection n="1" title="Objet">
        <p>Les présentes CGU/CGV régissent l'accès et l'utilisation de l'application {C.appName}, éditée par
        {" "}<Fill>{C.raisonSociale}</Fill>. En créant un compte, vous acceptez sans réserve ces conditions.</p>
      </LegalSection>
      <LegalSection n="2" title="Description du service">
        <p>{C.appName} est un assistant d'intelligence artificielle et une plateforme éducative dédiés à la
        compréhension des droits, à la lutte contre le racisme et les discriminations, et à l'accompagnement
        des jeunes et des parents. Le service propose des fonctions gratuites et des abonnements payants
        (Premium et Pro).</p>
      </LegalSection>
      <LegalSection n="3" title="Compte utilisateur">
        <p>Vous êtes responsable de la confidentialité de vos identifiants et de toute activité réalisée depuis
        votre compte. Vous vous engagez à fournir des informations exactes et à un usage conforme à la loi.</p>
      </LegalSection>
      <LegalSection n="4" title="Abonnements, prix et paiement">
        <ul className="space-y-1">
          <li>• <span className="text-white">Premium</span> : 9,99 €/mois (ou tarif annuel réduit lorsqu'il est proposé).</li>
          <li>• <span className="text-white">Pro</span> : 19,99 €/mois (ou tarif annuel réduit lorsqu'il est proposé).</li>
        </ul>
        <p className="mt-2">Les paiements web sont opérés par <span className="text-white">Stripe</span>. Les
        abonnements souscrits depuis l'application iOS sont opérés par <span className="text-white">Apple</span>
        {" "}(App Store) et ceux depuis Android par <span className="text-white">Google Play</span>, conformément
        à leurs conditions. Les abonnements sont <span className="text-white">reconductibles automatiquement</span>
        {" "}à échéance, sauf résiliation avant la date de renouvellement.</p>
      </LegalSection>
      <LegalSection n="5" title="Renouvellement et résiliation">
        <p>Vous pouvez résilier à tout moment depuis votre espace (portail client Stripe pour le web ; réglages
        de votre compte Apple ou Google pour les abonnements mobiles). La résiliation prend effet à la fin de la
        période en cours ; l'accès Premium/Pro reste actif jusqu'à cette date, sans nouveau prélèvement.</p>
      </LegalSection>
      <LegalSection n="6" title="Droit de rétractation">
        <p>Conformément au Code de la consommation, en demandant l'accès immédiat au service numérique, vous
        reconnaissez renoncer à votre droit de rétractation de 14 jours pour la partie déjà exécutée. Les
        conditions spécifiques des stores Apple/Google s'appliquent pour les achats mobiles.</p>
      </LegalSection>
      <LegalSection n="7" title="Contenus générés par l'IA">
        <p>Les réponses produites par l'IA sont des suggestions à visée informative et pédagogique. Elles ne
        remplacent pas un avis professionnel (juridique, médical, psychologique). Vous restez responsable de
        l'usage que vous faites des contenus générés.</p>
      </LegalSection>
      <LegalSection n="8" title="Usage acceptable">
        <p>Il est interdit d'utiliser le service à des fins illégales, haineuses, diffamatoires ou de
        harcèlement. Tout manquement peut entraîner la suspension ou la suppression du compte sans remboursement.</p>
      </LegalSection>
      <LegalSection n="9" title="Suppression de compte">
        <p>Vous pouvez supprimer votre compte et l'ensemble de vos données à tout moment depuis
        <span className="text-white"> Profil → Supprimer mon compte</span>. La suppression est définitive.</p>
      </LegalSection>
      <LegalSection n="10" title="Responsabilité et disponibilité">
        <p>Le service est fourni « en l'état ». L'éditeur met en œuvre les moyens raisonnables pour en assurer la
        disponibilité mais ne garantit pas une absence totale d'interruption ou d'erreur.</p>
      </LegalSection>
      <LegalSection n="11" title="Droit applicable">
        <p>Les présentes conditions sont soumises au droit français. À défaut de résolution amiable, les
        tribunaux compétents seront ceux du ressort du siège de l'éditeur.</p>
      </LegalSection>
      <LegalSection n="12" title="Contact">
        <p>Pour toute question relative aux présentes conditions : <Fill>{C.email}</Fill></p>
      </LegalSection>
    </LegalShell>
  );
}
